import React from 'react'
import cx from 'classnames'
import { useRef, useCallback } from 'sb-hooks'

import Headline from 'components/_new/typography/deprecated/Headline/Headline'
import CloseIcon from 'components/ui/CloseIcon/CloseIcon'

import s from './MobileModal.scss'


export type MobileModalProps = {
  title?: string | ReactIntlMessage
  placementOnTop?: boolean
  onBackdropClick?: () => void
  onClose?: () => void
}


const MobileModal: React.FunctionComponent<MobileModalProps> = (props) => {
  const { children, title, placementOnTop, onBackdropClick, onClose } = props

  const ref = useRef<HTMLDivElement>()

  const measuredRef = useCallback((node) => {
    if (node) {
      ref.current = node

      setTimeout(() => {
        ref.current.classList.add(s.visible)
      }, 0)
    }
  }, [])

  const handleBackdropClick = useCallback(() => {
    ref.current.classList.remove(s.visible)

    setTimeout(() => {
      if (typeof onBackdropClick === 'function') {
        onBackdropClick()
      }
    }, 300)
  }, [ onBackdropClick ])

  return (
    <div ref={measuredRef}>
      <div
        className={cx(s.modal, {
          [s.placementOnTop]: placementOnTop,
          [s.placementOnBottom]: !placementOnTop,
        })}
        role="dialog"
        aria-modal
      >
        {
          typeof onClose === 'function' && (
            <CloseIcon className={s.closeIcon} onClick={onClose} />
          )
        }
        {
          title && (
            <Headline title={title} size="md" />
          )
        }
        {children}
      </div>
      <div className={s.backdrop} onClick={handleBackdropClick} />
    </div>
  )
}


export default MobileModal
